package com.exura.features.plandefinition.data.remote.dto.element

import com.exura.features.plandefinition.domain.model.element.ElementType
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for PersistentElement.
 * Extends BasePlanElementDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("persistent_element")
data class PersistentElementDto(
    override val elementType: String = ElementType.PERSISTENT.name,
    override val durationInMinutes: Int,
    override val durationInDays: Int,
    val startRelativeDay: Int,
    val endRelativeDay: Int,
    val startRelativeHourOfDay: HourOfDay? = null,
    val endRelativeHourOfDay: HourOfDay? = null,
    val title: String,
    val description: String,
    val icon: String? = null,
    override val imageUrl: String? = null,
) : BasePlanElementDto()
